var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
        _vm.$style.genresList,
        _vm.horScroll && _vm.$style.genresListHorScroll,
        _vm.horScrollMobile && _vm.$style.genresListHorScrollMobile,
        _vm.padded && _vm.$style.genresListPadded,
    ]},_vm._l((_vm.genres),function(genre,index){return _c('div',{key:`genre${index}`,class:_vm.$style.genreItem},[_c('div',{class:_vm.$style.genre,on:{"click":function($event){_vm.$router.push({ name: 'genre', params: { id: _vm.genreLink(genre) } })}}},[_vm._v(" "+_vm._s(genre)+" ")]),(_vm.hasTypeTitle)?_c('div',{class:_vm.$style.typeTitle},[_vm._v("Genre")]):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }